"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const Description_1 = require("../Description");
const ui_1 = require("@completeanatomy/ui");
/**
 * @todo Check if we can use InfoBoxCard instead
 */
function CarouselCard({ className, detail, title, subtitle, img, showImage, }) {
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'CarouselCard_Container', children: [(0, jsx_runtime_1.jsxs)(Top, { "data-e2e": 'CarouselCard_Top', children: [showImage && img && (0, jsx_runtime_1.jsx)(Image, { src: (0, ui_1.fixRelativeUrl)(img), "data-e2e": 'CarouselCard_Image' }), (0, jsx_runtime_1.jsxs)(TitlesContainer, { "data-e2e": 'CarouselCard_TitlesContainer', children: [(0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'CarouselCard_Title', children: title }), (0, jsx_runtime_1.jsx)(Subtitle, { "data-e2e": 'CarouselCard_Subtitle', children: subtitle })] })] }), detail && (0, jsx_runtime_1.jsx)(StyledDescription, { "data-e2e": 'CarouselCard_StyledDescription', children: detail })] }));
}
exports.CarouselCard = CarouselCard;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  margin: 4px 0;
`;
const Top = styled_components_1.default.div `
  display: flex;
  min-height: 64px;
  margin: 0 10px;
`;
const TitlesContainer = styled_components_1.default.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;
`;
const StyledDescription = (0, styled_components_1.default)(Description_1.Description) `
  height: 20vh;
  margin-top: 4px;
  padding: 0 8px;

  font-size: 16px;
  text-align: justify;
`;
const Image = styled_components_1.default.img `
  width: 64px;
  height: 64px;
  margin-right: 8px;
  object-fit: cover;
`;
const Title = styled_components_1.default.div `
  font-weight: bold;
  font-size: 16px;

  user-select: text;
`;
const Subtitle = styled_components_1.default.div `
  font-weight: normal;
  font-size: 12px;

  user-select: text;
`;
